export const hasOwnProperty = (
  object: Record<string, unknown>,
  key: string,
) => {
  return Object.prototype.hasOwnProperty.call(object, key)
}
